import { postJson } from '../fetch';
import API_BASE_PATH from './basePath';

export const getCourseUnitRealisations = (ids, surveyId) => {
  const requestBody = { courseIds: ids };
  return postJson(`${API_BASE_PATH}/registry/course-realisations?${surveyId ? `&surveyId=${surveyId}` : ''}`, requestBody);
};

export const getStudents = (studentNumbers) => postJson(`${API_BASE_PATH}/registry/students`, { studentNumbers });

export const getTeachers = (emails) => {
  const requestBody = { emails };
  return postJson(`${API_BASE_PATH}/registry/teachers`, requestBody);
};
